import styled from 'styled-components';

export const Card = styled.div`
  border-radius: 8px;
  box-shadow: var(--shadow-sm);
  cursor: pointer;
  width: 100%;
  aspect-ratio: 1 / 1;
  max-width: 110px;
  margin: 0 auto;
  transition: border-color 0.3s, background-color 0.3s, opacity 0.3s;
  opacity: ${(props) => (props.isSelected ? '1' : '0.35')};
  border: ${(props) =>
    props.isSelected
      ? '3px solid var(--border-strong)'
      : '3px solid transparent'};
  box-sizing: border-box;

  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 4px;
  }

  &:hover {
    border-color: var(--accent-secondary);
    background-color: var(--accent-soft);
  }

  @media screen and (max-width: 768px) {
    max-width: none;
    border-width: 2px;
  }
`;
